import _ from 'underscore';
import $ from 'jquery';
import { download } from '@bingads-webui/download-service';
import { BaseImportStep } from '../base-import-step';
import template from './import-summary-step.pug';
import { ImportSummaryGridView } from './grid/index';

export class ImportSummaryStep extends BaseImportStep {
  initialize({
    deps,
  }) {
    super.initialize({
      deps,
    });

    this.download = download;
    this.showPayment = deps.showPayment;
    this.summaryDisclaimerKey = 'Import_SummaryPage_Disclaimer';
    this.summaryDisclaimerHelpLinkKey = 'Import_SummaryPage_Disclaimer_HelpLink';
    this.summaryHelpTopic = deps.summaryHelpTopic;
  }

  get events() {
    return {
      'click .export-errors': 'exportErrors',
    };
  }

  get title() {
    return this.buildTitle(this.i18n.get('Import_ImportSummary_Title'));
  }

  get actions() {
    const buttons = [];

    if (this.showPayment) {
      buttons.push({
        name: 'add-payment',
        displayText: this.i18n.get('Import_ImportSummary_AddPaymentButton'),
        method: 'addPayment',
        enabled: true,
        htmlAttributes: {
          class: 'btn btn-primary',
        },
      });
    }
    buttons.push({
      name: 'view-imported-campaigns',
      displayText: this.i18n.get('Import_ImportSummary_ViewImportedCampaigns'),
      method: 'viewImportedCampaigns',
      enabled: true,
      htmlAttributes: {
        class: 'btn btn-default',
      },
    });

    return buttons;
  }

  addPayment() {
    this.repository.redirectToAddPayment();
  }

  exportErrors() {
    this.repository.exportErrorFile(this.importId)
      .then((data) => {
        this.download(data);
      })
      .catch(() => {
        this.handleGenericError();
      });
  }

  viewImportedCampaigns() {
    this.repository.redirectToImportedCampaigns(this.showSuccessMessage);
  }

  willShow() {
    this.deps.logActivities.renderImportSummary.start();
    const state = this.getState();
    const data = state && state.summary;
    const hasImportErrors = _.any(data, row => row.Errors)
      || _.any(data, row => row.HasWarning);
    let summaryInfos = [];

    // not show summary info in continue import
    if (!this.deps.isContinueImport && !_.isEmpty(this.summaryInfos)) {
      ({ summaryInfos } = this);
    }

    this.$el.html(template({
      i18n: this.i18n,
      hasImportErrors,
      summaryInfos,
      isBatch: state.isBatch,
      isForVNext: this.isForVNext,
      newUETCreated: state.newUETCreated,
      summaryDisclaimerKey: this.summaryDisclaimerKey,
      summaryDisclaimerHelpLinkKey: this.summaryDisclaimerHelpLinkKey,
      summaryHelpTopic: this.summaryHelpTopic || 'ext50851',
      showAlert: this.showAlert,
    }));

    this.showSuccessMessage = _.any(data, row => row.Additions || row.Changes || row.Deletions);

    if (this.showSuccessMessage) {
      $('.page-title-subheader')
        .attr('role', 'alert')
        .html(this.i18n.get('Import_SuccessMessage'))
        .addClass('import-successMessage');
    }
    if (this.scheduleFormView) {
      $('.schedule-import-step').html(this.scheduleFormView.render().el);
    }

    if (data) {
      this.grid = new ImportSummaryGridView({
        data,
        i18n: this.i18n,
      });
      this.$('.import-summary-grid').html(this.grid.render().el);
    } else {
      // todo: add error log.
    }
    this.importId = state.importId;
    this.deps.logActivities.renderImportSummary.stop();
  }

  remove() {
    if (this.grid) {
      this.grid.remove();
      this.grid = null;
    }

    super.remove();
  }
}
